import { useFormAtom } from "@impero-com/common/utils/form/formAtom/hooks";
import { FormAtom } from "@impero-com/common/utils/form/formAtom/types";
import { Atom, useAtomValue } from "jotai";

import { FieldCmp } from "components/fieldBuilder/fieldCmp";

import { ControlField, getFieldTypeInfo } from "./fieldBuilderUtils";

interface ControlFieldCmpProps {
    fieldAtom: FormAtom<ControlField>;
    disabled?: boolean;
    openDrawer: () => void;
    fieldsAtom: Atom<ControlField[]>;
}
export function ControlFieldCmp({
    fieldAtom,
    openDrawer,
    fieldsAtom,
    disabled,
}: ControlFieldCmpProps) {
    const fields = useAtomValue(fieldsAtom);
    const { value: field, error } = useFormAtom(fieldAtom);
    return (
        <FieldCmp
            fields={fields}
            field={field}
            error={error}
            disabled={disabled}
            openDrawer={openDrawer}
            svgSrc={getFieldTypeInfo()(field.fieldType.type).svg}
        />
    );
}
